<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { ToggleGroupRoot, type ToggleGroupRootEmits, type ToggleGroupRootProps } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps<
  ToggleGroupRootProps & {
    class?: HTMLAttributes["class"];
  }
>();

const emit = defineEmits<ToggleGroupRootEmits>();

const rootProps = computed(() => {
  const { class: _cls, ...rest } = props;
  return rest;
});
</script>

<template>
  <ToggleGroupRoot
    v-bind="rootProps"
    :model-value="props.modelValue"
    :class="cn('flex flex-wrap gap-1', props.class)"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <slot />
  </ToggleGroupRoot>
</template>
